import { render, staticRenderFns } from "./MobileVersionsSettings.vue?vue&type=template&id=fee951a6&scoped=true"
import script from "./MobileVersionsSettings.vue?vue&type=script&lang=js"
export * from "./MobileVersionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee951a6",
  null
  
)

export default component.exports